<template>
  <div class="auth-main-wrapper col-lg-5 col-md-6 col-sm-12 mt-5">
    <div class="auth-inner-div w-100 text-center">
      <h3 class="auth-header">{{ $t('password_reminder') }}</h3>
    </div>
    <div class="auth-inner-form-div">
      <div class="auth-input">
        <span class="error-color font-small" v-if="errorStatus === 404">{{ $t('invalid_user') }}</span>
        <InputComponent v-for="input in form.inputs"
                        class="w-100 mx-auto"
                        :name-input="input.name"
                        :data-type="input.dataType"
                        :placeholder="$t(input.placeholder)"
                        v-model:data="input.value"
                        :msg="input.validation"></InputComponent>
      </div>
    </div>
    <div class="auth-inner-div w-100 pt-4 pb-5">
      <button class="auth-customer-login-button w-100"
              @click.prevent="sendReminder()"
              :disabled="loading"
              :class="{'less-padding-07': loading}">
        <span class="text-center">{{ $t('send_password_reminder') }}</span>
        <span v-if="loading" class="customer-loader"></span>
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import "./customerForgotPassword.scss"

import axios from "axios";
//@ts-ignore
import InputComponent from "../input/InputComponent";
import type {IForm} from "@/interfaces/IForm.interface";
import type {IInput} from "@/interfaces/IInput.interface";
import {useStore} from "vuex";
import {defineComponent} from "vue";
import apiService from "../../services/apiService";
import {routesConst} from "../../routes.js";

export default defineComponent({
  name: "CustomerForgotPasswordComponent",
  components: {
    InputComponent,
  },
  setup() {
    const store = useStore();

    return {
      store
    }
  },
  data() {
    return {
      loading: false,
      errorStatus: null,
      form: <IForm>{
        inputs: <IInput[]>[
          <IInput>{
            key: 'email', // NOTE prop binded with store
            name: 'email',
            dataType: 'text',
            placeholder: 'e_mail',
            value: null,
            validation: {
              state: true,
              message: null,
              rules: {
                required: {message: 'Please_Enter_your_email'}
              }
            }
          }
        ]
      }
    }
  },
  mounted () {},
  methods: {
    sendReminder(): void {
      this.loading = true;

      let data = {
        'locale': this.store.state.general.locale
      };

      for(const prop in this.form.inputs ) {
        if(!this.form.inputs.hasOwnProperty(prop)) {
          continue;
        }
        const input = this.form.inputs[prop];

        data[input.key] = input.value;
      }

      axios.post(apiService.customerForgotPassword(), data)
          .then(response => {
            this.$router.push(routesConst.FORGOT_PASSWORD_SUCCESS_PAGE);
          })
          .catch(error => {
            console.error(error);
            this.errorStatus = error.response.status;
          })
          .finally(() => {
            this.loading = false;
          });
    }
  }
});
</script>